import React from 'react';
import S from '../../UmbracoForm.styles';
const CheckBoxList = React.forwardRef(({ field, error, random = true, ...otherProps }, ref) => {
    let sortBy = undefined;
    if (random) {
        sortBy = () => {
            return 0.5 - Math.random();
        };
    }
    return (React.createElement(S.Field, { className: error?.message && 'invalid' },
        React.createElement(S.Label, { as: "span" }, field.caption),
        !field.required && field.caption && React.createElement(S.RequiredLabel, null, "(optional)"),
        React.createElement(S.List, null, field.values?.sort(sortBy).map((value, index) => (React.createElement(S.ControlLabel, { key: `option-${index}`, htmlFor: `${field.alias}-${index}` },
            React.createElement("input", { ref: ref, id: `${field.alias}-${index}`, type: "checkbox", required: field.required, value: value, ...otherProps }),
            React.createElement(S.CheckboxLabel, { dangerouslySetInnerHTML: {
                    __html: 'temp caption'.replaceAll(/\*([^*]+?)\*/g, '<strong>$1</strong>'),
                } }))))),
        error && React.createElement(S.Error, null, error.message)));
});
CheckBoxList.displayName = 'CheckBoxList';
export default CheckBoxList;
